module.exports = __webpack_public_path__ + "img/TR-1920.ff2099c4.jpg";